export default __webpack_public_path__ + "static/media/design.e25486a6.png";